export default __webpack_public_path__ + "static/media/mexico-square.71c1577f.svg";